export const environment = {
  production: false,
  env: 'stg',
  version: 'stg-97055bd8',
  feedbackDelay: 5000,
  api: 'https://stg.api.roz.copec.cl',
};
